(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("RequestDemo2020ModalController", RequestDemo2020ModalController);

    RequestDemo2020ModalController.$inject = ['$scope', 'modalData', '$stateParams', '$sce', '$httpParamSerializer'];
    function RequestDemo2020ModalController($scope, modalData, $stateParams, $sce, $httpParamSerializer) {

        var self = this;
        self.iframe = '';

        var modals = {
            'demo_request': {
                title: $filter('translate')('Discover Harri'),
                formTypeLabel: 'Request Demo'
            },
            'contact_sales': {
                title: $filter('translate')('Contact Sales'),
                formTypeLabel: 'Contact Sales'
            }
        };

        self.modalInfo = modals[modalData.type] || modals.demo_request;

        var withoutUnderscore = function (value) {
            if(!value) {
                return value;
            }
            return value.split('_').join(' ');
        };

        var createIFrame = function() {

            var utmTrackingData = {
                user_location: modalData.pageVersion,
                utm_campaign: withoutUnderscore($stateParams.utm_campaign),
                utm_content: withoutUnderscore($stateParams.utm_content),
                utm_medium: withoutUnderscore($stateParams.utm_medium),
                utm_source: withoutUnderscore($stateParams.utm_source),
                utm_term: withoutUnderscore($stateParams.utm_term),
                Referrer_link: window.location.pathname,
                type: self.modalInfo.formTypeLabel
            };

            var formLink = 'https://go.harri.com/l/234402/2020-02-18/b92j3';
            if (modalData.pageVersion && modalData.pageVersion === 'UK') {
                formLink = 'https://go.harri.com/l/234402/2020-04-27/bggcl';
            }

            var url = formLink + '?' + $httpParamSerializer(utmTrackingData);
            var wrap = document.createElement('div');
            var iframe = document.createElement("iframe");
            iframe.setAttribute("src", url);
            iframe.style.width = "100%";
            iframe.style.height = "580px";
            iframe.frameBorder = 0;

            wrap.appendChild(iframe.cloneNode(true));
            self.iframe = $sce.trustAsHtml(wrap.innerHTML);

        };

        createIFrame();

        self.close = function () {
            $scope.$hide();
        };
    }

})();

var getRequestDemo2020Modal = function (modalData) {
    $('head').append('<link rel="stylesheet" href="../wp-pages/Abside-fonts.css" />');
    return {
        controller: 'RequestDemo2020ModalController',
        controllerAs: '$ctrl',
        templateUrl: '../scripts/global-directives/request-demo-2020/request-demo-2020.modal.html',
        show: true,
        backdrop: 'static',
        resolve: {
            modalData: modalData
        }
    };
};
